/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	export class OrbitCameraAttitude {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(distance: number = 0, angle: number = 0, height: number = 0) {
			this.set(distance, angle, height);
		}


		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public set(distance: number, angle: number, height: number): void {
			this.distance = distance;
			this.angle = angle;
			this.height = height;
		}

		public getDistance(): number {
			return this.distance;
		}

		public getAngle(): number {
			return this.angle;
		}

		public getHeight(): number {
			return this.height;
		}


		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private distance: number;
		private angle: number;
		private height: number;
	}
}
